export default "__VITE_ASSET__dd4ce64e__"